import { useEffect, useState } from 'react'

import {
  DEFAULT_LANGUAGE,
  ESSENTIALS_CATEGORY,
  ESSENTIALS_GET_ARTICLES_BY_CATEGORY_QUERY,
  ESSENTIALS_GET_SUBCATEGORIES_QUERY,
  ESSENTIALS_QUERY_ID,
  ESSENTIALS_SUBCATEGORY,
  EssentialsArticleRaw,
  runEssentialsQuery,
} from '@lyrahealth-inc/shared-app-logic'

/** Fetches all articles under a category eg "parenting support"  */
export const useGetEssentialsArticlesByCategory = ({
  essentialsCmsUrl,
  userDisplayLanguage,
  essentialsCategories,
  essentialsExcludedSubcategories,
  logError,
  skipFetch,
}: {
  essentialsCmsUrl: string
  userDisplayLanguage: string
  essentialsCategories?: ESSENTIALS_CATEGORY[]
  essentialsExcludedSubcategories?: ESSENTIALS_SUBCATEGORY[]
  logError?: (error: Error) => void
  skipFetch?: boolean
}) => {
  const [articles, setArticles] = useState<EssentialsArticleRaw[]>([])

  const locale = userDisplayLanguage || DEFAULT_LANGUAGE

  useEffect(() => {
    if (skipFetch || !(essentialsCategories && essentialsCategories.length > 0 && essentialsCmsUrl)) {
      return
    }

    const getArticles = async () => {
      let articlesList: EssentialsArticleRaw[] = []
      const categoriesResult = await Promise.all(
        essentialsCategories.map((category) =>
          runEssentialsQuery({
            locale,
            slug: category,
            query: ESSENTIALS_GET_SUBCATEGORIES_QUERY,
            essentialsCmsUrl,
            logError,
            url: `?${ESSENTIALS_QUERY_ID.GET_SUBCATEGORIES}=true`,
          }),
        ),
      )

      for (const category of categoriesResult) {
        const categoryData = category[0]
        const articlesForSubcategoryResult = await Promise.all(
          categoryData.subcategories
            .filter(
              (item: { slug: string }) =>
                !essentialsExcludedSubcategories?.includes(item.slug as ESSENTIALS_SUBCATEGORY),
            )
            .map((item: { slug: string }) => {
              return runEssentialsQuery({
                locale: locale,
                slug: item.slug,
                query: ESSENTIALS_GET_ARTICLES_BY_CATEGORY_QUERY,
                essentialsCmsUrl: essentialsCmsUrl,
                logError: logError,
                url: `?${ESSENTIALS_QUERY_ID.GET_ARTICLES_BY_CATEGORY}=true`,
              })
            }),
        )
        for (const articlesForSubcategory of articlesForSubcategoryResult) {
          articlesList = articlesList.concat(articlesForSubcategory)
        }
      }

      setArticles(articlesList)
    }
    getArticles()
  }, [essentialsCategories, essentialsCmsUrl, essentialsExcludedSubcategories, locale, logError, skipFetch])

  return articles
}
